import { toast } from "react-toastify";
import { ComponentService } from "../Services/Axios/Api";
import { generateDynamicCSS } from "../ComponentsMap";

class DonationCard {
    data = {};
    constructor() {
        this.data = {
            id: '4',
            ComponentName: 'DonationCard',
            normalCard: {
                display: 'normal',
                animation: {
                    animationType: 'fade-up',
                    animationDuration: '800',
                    animationDelay: '0'
                },
                NormalDonationCard:{
                    borderRadius: '15px',
                    backgroundColor: '#ffffff',
                    color: '#000000'
                },
                NormalDonationCardImageContainer:{
                    borderRadius: '15px'
                },
                NormalDonationCardText:{
                    color: '#000000'
                },
                NormalDonationCardTextHover:{
                    color: '#000000'
                }
            },
            progressingCard: {
                display: 'normal',
                animation: {
                    animationType: 'fade-up',
                    animationDuration: '800',
                    animationDelay: '0'
                },
                ProgressingDonationCard:{
                    borderRadius: '15px',
                    backgroundColor: '#ffffff',
                    color: '#000000'
                },
                ProgressingDonationCardImageContainer:{
                    borderRadius: '15px'
                },
                ProgressingDonationCardText:{
                    color: '#000000'
                },
                ProgressingDonationCardTextHover:{
                    color: '#000000'
                },
                ProgressingDonationCardProgressBar:{
                    backgroundColor: '#000000'
                }
            }
        };
    }

    // ID
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }

    // Component Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(name) { this.data.ComponentName = name; }

    // Normal Card Properties
    getNormalCard() { return this.data.normalCard; }
    setNormalCard(normalCard) { this.data.normalCard = normalCard; }

    getNormalCardDisplay() { return this.data.normalCard.display; }
    setNormalCardDisplay(display) { this.data.normalCard.display = display; }

    
    getNormalCardBorderRadius() { return this.data.normalCard.NormalDonationCard.borderRadius; }
    setNormalCardBorderRadius(radius) { this.data.normalCard.NormalDonationCard.borderRadius = radius; }

    getNormalCardBackgroundColor() { return this.data.normalCard.NormalDonationCard.backgroundColor; }
    setNormalCardBackgroundColor(color) { this.data.normalCard.NormalDonationCard.backgroundColor = color; }

    getNormalCardColor() { return this.data.normalCard.NormalDonationCard.color; }
    setNormalCardColor(color) { this.data.normalCard.NormalDonationCard.color = color; }

    getNormalImageBorderRadius() { return this.data.normalCard.NormalDonationCardImageContainer.borderRadius; }
    setNormalImageBorderRadius(radius) { this.data.normalCard.NormalDonationCardImageContainer.borderRadius = radius; }

    getNormalTextColor() { return this.data.normalCard.NormalDonationCardText.color; }
    setNormalTextColor(color) { this.data.normalCard.NormalDonationCardText.color = color; }

    getNormalTextHoverColor() { return this.data.normalCard.NormalDonationCardTextHover.color; }
    setNormalTextHoverColor(color) { this.data.normalCard.NormalDonationCardTextHover.color = color; }

    // Progressing Card Properties
    getProgressingCard() { return this.data.progressingCard; }
    setProgressingCard(progressingCard) { this.data.progressingCard = progressingCard; }

    getProgressingCardDisplay() { return this.data.progressingCard.display; }
    setProgressingCardDisplay(display) { this.data.progressingCard.display = display; }

    getProgressingCardBorderRadius() { return this.data.progressingCard.ProgressingDonationCard.borderRadius; }
    setProgressingCardBorderRadius(radius) { this.data.progressingCard.ProgressingDonationCard.borderRadius = radius; }

    getProgressingCardBackgroundColor() { return this.data.progressingCard.ProgressingDonationCard.backgroundColor; }
    setProgressingCardBackgroundColor(color) { this.data.progressingCard.ProgressingDonationCard.backgroundColor = color; }

    getProgressingCardColor() { return this.data.progressingCard.ProgressingDonationCard.color; }
    setProgressingCardColor(color) { this.data.progressingCard.ProgressingDonationCard.color = color; }

    getProgressingImageBorderRadius() { return this.data.progressingCard.ProgressingDonationCardImageContainer.borderRadius; }
    setProgressingImageBorderRadius(radius) { this.data.progressingCard.ProgressingDonationCardImageContainer.borderRadius = radius; }

    getProgressingTextColor() { return this.data.progressingCard.ProgressingDonationCardText.color; }
    setProgressingTextColor(color) { this.data.progressingCard.ProgressingDonationCardText.color = color; }

    getProgressingTextHoverColor() { return this.data.progressingCard.ProgressingDonationCardTextHover.color; }
    setProgressingTextHoverColor(color) { this.data.progressingCard.ProgressingDonationCardTextHover.color = color; }

    getProgressBarColor() { return this.data.progressingCard.ProgressingDonationCardProgressBar.backgroundColor; }
    setProgressBarColor(color) { this.data.progressingCard.ProgressingDonationCardProgressBar.backgroundColor = color; }

    // Normal animation getters/setters
    getNormalAnimation() { return this.data.normalCard.animation || { animationType: 'fade-up', animationDuration: '800', animationDelay: '0' }; }
    setNormalAnimation(anim) { this.data.normalCard.animation = { ...this.getNormalAnimation(), ...anim }; }
    getNormalAnimationType() { return this.getNormalAnimation().animationType; }
    setNormalAnimationType(type) { this.setNormalAnimation({ animationType: type }); }
    getNormalAnimationDuration() { return this.getNormalAnimation().animationDuration; }
    setNormalAnimationDuration(duration) { this.setNormalAnimation({ animationDuration: duration }); }
    getNormalAnimationDelay() { return this.getNormalAnimation().animationDelay; }
    setNormalAnimationDelay(delay) { this.setNormalAnimation({ animationDelay: delay }); }

    // Progressing animation getters/setters
    getProgressingAnimation() { return this.data.progressingCard.animation || { animationType: 'fade-up', animationDuration: '800', animationDelay: '0' }; }
    setProgressingAnimation(anim) { this.data.progressingCard.animation = { ...this.getProgressingAnimation(), ...anim }; }
    getProgressingAnimationType() { return this.getProgressingAnimation().animationType; }
    setProgressingAnimationType(type) { this.setProgressingAnimation({ animationType: type }); }
    getProgressingAnimationDuration() { return this.getProgressingAnimation().animationDuration; }
    setProgressingAnimationDuration(duration) { this.setProgressingAnimation({ animationDuration: duration }); }
    getProgressingAnimationDelay() { return this.getProgressingAnimation().animationDelay; }
    setProgressingAnimationDelay(delay) { this.setProgressingAnimation({ animationDelay: delay }); }

    // Data operations
    getData() { return this.data; }
    setData(data) { this.data = data; }

    renderStyles() {
        // Normal Card Styles
        generateDynamicCSS("NormalDonationCard", [
            { backgroundColor: this.data.normalCard.NormalDonationCard.backgroundColor },
            { color: this.data.normalCard.NormalDonationCard.color },
            { borderRadius: this.data.normalCard.NormalDonationCard.borderRadius }
        ]);

        generateDynamicCSS("NormalDonationCardImageContainer", [
            { borderRadius: this.data.normalCard.NormalDonationCardImageContainer.borderRadius }
        ]);

        generateDynamicCSS("NormalDonationCardText", [
            { color: this.data.normalCard.NormalDonationCardText.color }
        ]);

        generateDynamicCSS("NormalDonationCardTextHover", [
            { color: this.data.normalCard.NormalDonationCardTextHover.color }
        ]);

        // Progressing Card Styles
        generateDynamicCSS("ProgressingDonationCard", [
            { backgroundColor: this.data.progressingCard.ProgressingDonationCard.backgroundColor },
            { color: this.data.progressingCard.ProgressingDonationCard.color },
            { borderRadius: this.data.progressingCard.ProgressingDonationCard.borderRadius }
        ]);

        generateDynamicCSS("ProgressingDonationCardImageContainer", [
            { borderRadius: this.data.progressingCard.ProgressingDonationCardImageContainer.borderRadius }
        ]);

        generateDynamicCSS("ProgressingDonationCardText", [
            { color: this.data.progressingCard.ProgressingDonationCardText.color }
        ]);

        generateDynamicCSS("ProgressingDonationCardTextHover", [
            { color: this.data.progressingCard.ProgressingDonationCardTextHover.color }
        ]);

        generateDynamicCSS("ProgressingDonationCardProgressBar", [
            { backgroundColor: this.data.progressingCard.ProgressingDonationCardProgressBar.backgroundColor }
        ]);
    }

    async load() {
        try {
            const response = await ComponentService.getComponent(this.data.ComponentName);
            const data = JSON.parse(response[0]?.data);
            this.setData(data);
            this.setId(response[0]?.id);
            this.renderStyles();
            return data;
        } catch (error) {
            throw new Error(error.response?.data || 'Failed to load donation card data');
        }
    }

    async save() {
        try {
            const response = await ComponentService.SaveData(this.getId(), this.getData());
            this.renderStyles();
            return response;
        } catch (error) {
            throw new Error(error.response?.data || 'Failed to save donation card data');
        }
    }
}

export const createDonationCardInstance = () => new DonationCard(); 